<h2 matDialogTitle class="mat-h2">Schedule Dynamic Ad</h2>

<mat-dialog-content>
  <mat-divider></mat-divider>
  <p class="mat-body-2">Schedule updates to ads to occur at a specific time. The ad will be tagged as dynamic, and affiliates that integrated using dynamic javascript will automatically receive the update.</p>

  <ng-container [formGroup]="topFormGroup">
    <table mat-table [dataSource]="dataSource" formArrayName="rows">
      <ng-container matColumnDef="actions">
        <td mat-cell *matCellDef="let row; let i=index">
          <button mat-icon-button (click)="onRemoveScheduleEntryClick(i)" matTooltip="Cancel Dynamic Ad"><mat-icon color="accent">cancel</mat-icon></button>
        </td>
      </ng-container>

      <ng-container matColumnDef="scheduleStartDate">
        <td mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
          <div class="td-liner-inputs">
            <mat-form-field subscriptSizing="fixed">
              <mat-label>Change Date</mat-label>
              <input matInput [matDatepicker]="scheduleStartDatePicker" formControlName="scheduleStartDateStartOfDay">
              <mat-datepicker-toggle matSuffix [for]="scheduleStartDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #scheduleStartDatePicker></mat-datepicker>
              <mat-hint>Date the ad updates.</mat-hint>
              <mat-error>{{row.get('scheduleStartDateStartOfDay').errors | validationMessage}}</mat-error>
            </mat-form-field>

            <mat-form-field subscriptSizing="fixed">
              <mat-label>Change Time</mat-label>
              <mat-select formControlName="scheduleStartDateHour">
                <mat-option *ngFor="let option of hourTimeOptions" [value]="option.value">{{option.label}}</mat-option>
              </mat-select>
              <mat-error>{{row.get('scheduleStartDateHour').errors | validationMessage}}</mat-error>
            </mat-form-field>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="ad">
        <td mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
          @if (merchantAd.ad_type === 'banner') {
            <img [ngSrc]="row.get('imageUrl').value" (click)="onImgClick(row.get('clientSideId').value)" width="{{merchantAd.image_width}}" height="{{merchantAd.image_height}}">
            <input type="file" [id]="'fileInput[' + row.get('clientSideId').value + ']'" accept=".gif,.jpeg,.jpg,.png" style="display:none" (change)="onFileInputChange($event, row.get('scheduleId').value, row.get('imageUrl'))">
            <div class="wash-out" style="text-align: center">Banner {{merchantAd.image_width}}x{{merchantAd.image_height}}</div>
          }
          @if (merchantAd.ad_type === 'text') {
            <mat-form-field subscriptSizing="fixed">
              <mat-label>Text Ad Link/Copy</mat-label>
              <textarea matInput cdkTextareaAutosize formControlName="linkText" #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
              <mat-error>{{row.get('linkText').errors | validationMessage}}</mat-error>
            </mat-form-field>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="adDetails">
        <td mat-cell *matCellDef="let row; let i=index" [formGroupName]="i">
          <div class="td-liner-inputs">
            <mat-form-field subscriptSizing="fixed">
              <mat-label>Ad Name</mat-label>
              <input matInput placeholder="placeholder" formControlName="adTitle">
              <mat-error>{{row.get('adTitle').errors | validationMessage}}</mat-error>
            </mat-form-field>

            <mat-form-field subscriptSizing="fixed">
              <mat-label>Destination URL</mat-label>
              <input matInput placeholder="placeholder" formControlName="destinationUrl">
              <mat-error>{{row.get('destinationUrl').errors | validationMessage}}</mat-error>
            </mat-form-field>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="footer">
        <td mat-footer-cell *matFooterCellDef colspan="5" style="text-align: center;">
          <button mat-raised-button type="button" class="blue" (click)="onAddDynamicUpdateClick()">Add Dynamic Update</button>
        </td>
      </ng-container>

      <tr mat-row *matRowDef="let row; columns: ['actions', 'ad', 'adDetails', 'scheduleStartDate'];"></tr>
      <tr mat-footer-row *matFooterRowDef="['footer']"></tr>
    </table>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" class="white" [mat-dialog-close]="false">Cancel</button> &nbsp;
  <button mat-raised-button type="button" color="primary"
    [disabled]="!topFormGroup.valid || savingInProgress || (topControls.rows.length === 0 && merchantAdSchedules.length === 0)" (click)="onSaveClick()">{{savingInProgress ? 'Saving...' : 'Save'}}</button>
</mat-dialog-actions>
